import { MutationTree } from "vuex";
import { IPropertyEditState } from "../property-states.store";
import propertyVideoTypesStore from "./property-video-types.store";
import { IPropertyVideoModel } from "../../../../models/property";
import { itemStateConstant } from "../../../../common";

const videoMutations: MutationTree<IPropertyEditState> = <MutationTree<IPropertyEditState>>{
	[propertyVideoTypesStore.Set.LIST_OF_PROPERTY_VIDEOS]: (state: IPropertyEditState, listOfPropertyVideos: IPropertyVideoModel[]) => {
		state.property.Videos = listOfPropertyVideos;
	}
	, [propertyVideoTypesStore.Set.ADD_TO_LIST]: (state: IPropertyEditState, videos: IPropertyVideoModel[]) => {
        const currentVideos = Array.isArray(state.property.Videos) ? state.property.Videos : [];
        const next = Array.isArray(videos) ? videos : [];
        const currentPropertyId = state.property?.Id;

        // Check if incoming videos belong to current property
        const incomingPropertyId = next.length > 0 ? next[0].ObjectId : null;
        if (incomingPropertyId && currentPropertyId && incomingPropertyId !== currentPropertyId) {
            // Incoming videos are for a different property - ignore them
            return;
        }

        // Helper function to check if two videos match
        const videosMatch = (a: IPropertyVideoModel, b: IPropertyVideoModel): boolean => {
            // Must be same property
            if (a.ObjectId && b.ObjectId && a.ObjectId !== b.ObjectId) return false;

            if (a.Id && b.Id && a.Id === b.Id) return true;
            if (a.VideoUid && b.VideoUid && a.VideoUid === b.VideoUid) return true;
            if (a.VideoId && b.VideoId && a.VideoId === b.VideoId) return true;
            // Also match by Order (slot) if both have ObjectId matching
            if (a.ObjectId && b.ObjectId && a.ObjectId === b.ObjectId &&
                a.Order !== undefined && b.Order !== undefined && a.Order === b.Order) {
                return true;
            }
            return false;
        };

        // Start with a copy of current videos
        const merged: IPropertyVideoModel[] = [...currentVideos];

        // First, process all non-deleted videos to add/update them
        const activeVideos = next.filter(v => v.ItemState !== itemStateConstant.Deleted);
        const deletedVideos = next.filter(v => v.ItemState === itemStateConstant.Deleted);

        // Process active videos first
        activeVideos.forEach(video => {
            const matchIndex = merged.findIndex(item => videosMatch(item, video));

            if (matchIndex === -1) {
                // New video, add it
                merged.push(video);
            } else {
                // Existing video, merge/update it
                const existing = merged[matchIndex];
                const mergedVideo: IPropertyVideoModel = { ...existing };
                Object.keys(video || {}).forEach((key: keyof IPropertyVideoModel) => {
                    const value = video[key];
                    if (value !== undefined) {
                        mergedVideo[key] = value as never;
                    }
                });
                merged[matchIndex] = mergedVideo;
            }
        });

        // Then process deleted videos - but only mark as deleted if the video ID matches exactly
        // Don't match by Order for deletions to avoid marking newly added videos as deleted
        deletedVideos.forEach(video => {
            // Only match by exact ID, VideoUid, or VideoId - NOT by Order
            const matchIndex = merged.findIndex(item => {
                if (item.Id && video.Id && item.Id === video.Id) return true;
                if (item.VideoUid && video.VideoUid && item.VideoUid === video.VideoUid) return true;
                if (item.VideoId && video.VideoId && item.VideoId === video.VideoId) return true;
                return false;
            });

            if (matchIndex !== -1) {
                merged[matchIndex] = { ...merged[matchIndex], ItemState: itemStateConstant.Deleted };
            }
        });

        state.property.Videos = merged;
	},
    [propertyVideoTypesStore.Set.DELETE_PROPERTY_VIDEO]: (state: IPropertyEditState, id: number) => {
        // UPDATE ITEM IF THIS IS ITEM HAD BE STORED IN THE SERVICE
		// DELETE ITEM IF THIS IS ITEM HAD JUST ADDED
		let item = state.property.Videos?.find(x => x.Id === id);
        if (!item) return;
		if (item.ItemState === itemStateConstant.Added) {
			let index = state.property.Videos.indexOf(item);
			state.property.Videos.splice(index, 1);
		} else {
			item.ItemState = itemStateConstant.Deleted;
		}
    }
}

export default videoMutations;
